import { render, staticRenderFns } from "./UnknownOrigins.vue?vue&type=template&id=1c16ae80&scoped=true"
import script from "./UnknownOrigins.vue?vue&type=script&setup=true&lang=js"
export * from "./UnknownOrigins.vue?vue&type=script&setup=true&lang=js"
import style0 from "./UnknownOrigins.vue?vue&type=style&index=0&id=1c16ae80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c16ae80",
  null
  
)

export default component.exports